<template>
  <div id="application">
    <head>
      <link
        rel="shortcut icon"
        type="image/x-icon"
        href="//cityofphiladelphia.github.io/patterns/images/favicon.ico"
      >
      <meta
        name="viewport"
        content="width=device-width"
      >
    </head>
    <body>
      <div class="grid-x mbm header-container">
        <div class="header-content grid-container">
          <div class="triangle" />
          <h4 v-html="owners[0].name" />
          <h1
            class="mvn"
            v-html="postInfo.post_title"
          />
        </div>
      </div>
      <main class="content">
        <div class="grid-container pbxl">
          <div class="app-container">
            <router-view 
              v-if="!loading"
              :longform-document="longformDocument"
              :post-info="postInfo"
              :update-history="updateHistory"
              :owners="owners"
            />
            <PrintFootnotes
              v-if="!loading"
              :footnotes="footnotes"
            />
            <div
              v-show="loading"
              class="loading-icon ptxl center"
            >
              <i class="fas fa-spinner fa-spin fa-3x loadingdir" />
            </div>
          </div>
        </div>
      </main>
    </body>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import PrintFootnotes from '@/components/PrintFootnotes.vue';
import { ClientTable } from 'vue-tables-2';

Vue.use(ClientTable, {
  options: {}, 
  useVuex: false,
  theme: 'bootstrap3',
  template: 'default',
});

export default {
  name: 'App',
  components: {
    PrintFootnotes,
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      longformDocument: {},
      owners: [],
      postInfo: {},
      updateHistory: [],
      footnotes: [],
      loading: true,
    };
  },
  computed: {
    getPostId: function() {
      return (window.phila_js_vars && window.phila_js_vars.postID) ? window.phila_js_vars.postID : process.env.VUE_APP_TEST_ID;
    },
  },
  mounted () {
    let vm = this;
    vm.init();
  },
  methods: {
    getLongformDocument () {
      let vm = this;
      return axios.get(vm.apiUrl+vm.getPostId).then(async (result) => {
        if(result.data.children) {
          Object.entries(result.data.children).forEach(([ key, section ], i) => {
            section.index = (i+1);
            if(section.footnote_copy && section.footnote_index) {
              vm.footnotes.push({
                copy : section.footnote_copy,
                index : section.footnote_index,
                section : section.index,
              });
            }
            Object.defineProperty(result.data.children, section.menu_order, Object.getOwnPropertyDescriptor(result.data.children, key));
            delete result.data.children[key];
            Object.entries(section.children).forEach(([ key1, section1 ], j) => {
              section1.index = (i+1)+'.'+(j+1);
              if(section1.footnote_copy && section1.footnote_index) {
                vm.footnotes.push({
                  copy : section1.footnote_copy,
                  index : section1.footnote_index,
                  section : section1.index,
                });
              }
              Object.defineProperty(section.children, section1.menu_order, Object.getOwnPropertyDescriptor(section.children, key1));
              delete section.children[key1];
              Object.entries(section1.children).forEach(([ key2, section2 ], k) => {
                section2.index = (i+1)+'.'+(j+1)+'.'+(k+1);
                if(section2.footnote_copy && section2.footnote_index) {
                  vm.footnotes.push({
                    copy : section2.footnote_copy,
                    index : section2.footnote_index,
                    section : section2.index,
                  });
                }
                Object.defineProperty(section1.children, section2.menu_order, Object.getOwnPropertyDescriptor(section1.children, key2));
                delete section1.children[key2];
                Object.entries(section2.children).forEach(([ key3, section3 ], m) => {
                  section3.index = (i+1)+'.'+(j+1)+'.'+(k+1)+'.'+(m+1);
                  if(section3.footnote_copy && section3.footnote_index) {
                    vm.footnotes.push({
                      copy : section3.footnote_copy,
                      index : section3.footnote_index,
                      section : section3.index,
                    });
                  }
                  Object.defineProperty(section2.children, section3.menu_order, Object.getOwnPropertyDescriptor(section2.children, key3));
                  delete section2.children[key3];
                  Object.entries(section3.children).forEach(([ key4, section4 ], n) => {
                    section4.index = (i+1)+'.'+(j+1)+'.'+(k+1)+'.'+(m+1)+'.'+(n+1);
                    if(section4.footnote_copy && section4.footnote_index) {
                      vm.footnotes.push({
                        copy : section4.footnote_copy,
                        index : section4.footnote_index,
                        section : section4.index,
                      });
                    }
                    Object.defineProperty(section3.children, section4.menu_order, Object.getOwnPropertyDescriptor(section3.children, key4));
                    delete section3.children[key4];
                    Object.entries(section4.children).forEach(([ key5, section5 ], p) => {
                      section5.index = (i+1)+'.'+(j+1)+'.'+(k+1)+'.'+(m+1)+'.'+(n+1)+'.'+(p+1);
                      if(section5.footnote_copy && section5.footnote_index) {
                        vm.footnotes.push({
                          copy : section5.footnote_copy,
                          index : section5.footnote_index,
                          section : section5.index,
                        });
                      }
                      Object.defineProperty(section4.children, section5.menu_order, Object.getOwnPropertyDescriptor(section4.children, key5));
                      delete section4.children[key5];
                      Object.entries(section5.children).forEach(([ key6, section6 ], q) => {
                        section6.index = (i+1)+'.'+(j+1)+'.'+(k+1)+'.'+(m+1)+'.'+(n+1)+'.'+(p+1)+'.'+(q+1);
                        if(section6.footnote_copy && section6.footnote_index) {
                          vm.footnotes.push({
                            copy : section6.footnote_copy,
                            index : section6.footnote_index,
                            section : section6.index,
                          });
                        }
                        Object.defineProperty(section5.children, section6.menu_order, Object.getOwnPropertyDescriptor(section5.children, key6));
                        delete section5.children[key6];
                        Object.entries(section6.children).forEach(([ key7, section7 ], r) => {
                          section7.index = (i+1)+'.'+(j+1)+'.'+(k+1)+'.'+(m+1)+'.'+(n+1)+'.'+(p+1)+'.'+(q+1)+'.'+(r+1);
                          if(section7.footnote_copy && section7.footnote_index) {
                            vm.footnotes.push({
                              copy : section7.footnote_copy,
                              index : section7.footnote_index,
                              section : section7.index,
                            });
                          }
                          Object.defineProperty(section6.children, section7.menu_order, Object.getOwnPropertyDescriptor(section6.children, key7));
                          delete section6.children[key7];
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        }
        vm.owners = result.data.owners;
        vm.postInfo = result.data.post;
        vm.longformDocument = result.data.children;
        vm.updateHistory = result.data.updateHistory.phila_longform_document_update;
        return true;
      }).catch(() => {
        return false;
      });
    },
    async init () {
      let vm = this;
      vm.loading = true;
      await vm.getLongformDocument();
      vm.loading = false;
    },
  },
};
</script>